/** @jsxImportSource @emotion/react */
import { COLORS } from 'colors';
import { CheckCircledIcon } from 'components/icons/icons';
import {
  cardBodyStyle,
  cardHeaderStyle,
  cardStyle,
  containerStyle,
  featuresTitleStyle,
  featureStyle,
  gridStyle,
  headerStyle,
  periodStyle,
  planDescStyle,
  planNameStyle,
  priceStyle,
  priceWrapperStyle,
  sectionStyle
} from './styles/PricingSection.styles';
import pricePlans from 'static/data/pricePlans';

export default function PricingSection() {
  return (
    <section css={sectionStyle}>
      <div css={containerStyle}>
        {/* Header */}
        <div css={headerStyle}>
          <h1>Choose Your Coverage Plan</h1>
        </div>

        {/* Pricing Cards */}
        <div css={gridStyle}>
          {pricePlans.map((plan) => (
            <div key={plan.name} css={cardStyle}>
              <div css={cardHeaderStyle}>
                <h2 css={planNameStyle}>{plan.name}</h2>
                <p css={planDescStyle}>{plan.description}</p>
                <div css={priceWrapperStyle}>
                  <span css={priceStyle}>${plan.price}</span>
                  <span css={periodStyle}>per {plan.period}</span>
                </div>
              </div>

              <div css={cardBodyStyle}>
                <div css={featuresTitleStyle}>This includes:</div>
                {plan.features.map((feature, idx) => (
                  <div key={idx} css={featureStyle}>
                    <div width={14}>
                      <CheckCircledIcon fill={COLORS.PRIMARY} />
                    </div>
                    <span>{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
